module.exports = __webpack_public_path__ + "icons/affirm-icon-40317a162943d2fc4d00c9145c223a5d.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/affirm-icon.svg
// module id = Rh92
// module chunks = 20